import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { giftCardApi } from '@root/api';
import Modal from '@root/components/modal';
import Toast from '@root/components/toast';

const useGiftCardForm = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [checking, setChecking] = useState(false);
  const [code, setCode] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const onClickUseRules = useCallback(() => {
    const Desc = (
      <div className="alert-msg">
        <p>{t('gift_card_use_rules_tips_1')}</p>
        <p>{t('gift_card_use_rules_tips_2')}</p>
        <p>{t('gift_card_use_rules_tips_3')}</p>
        <p>{t('gift_card_use_rules_tips_4')}</p>
        <p>{t('gift_card_use_rules_tips_5', { email: 'Support@aidot.com' })}</p>
      </div>
    );

    Modal.alert({
      title: t('gift_card_use_rules'),
      content: Desc,
      confirm: t('ok'),
    });
  }, [t]);

  const onCheckCode = useCallback(() => {
    if (!code) {
      return;
    }
    setChecking(true);
    giftCardApi
      .checkGiftCard(code)
      .then(() => {
        setChecking(false);
        navigate(`/giftCard/${code}/packages`);
      })
      .catch((reason) => {
        Toast.destroy();
        setChecking(false);
        const { data } = reason.response || {};
        let msg = t('gift_card_error');
        if (reason.response?.status === 400 && data.desc) {
          msg = data.desc;
        }
        Toast.info(msg);
      });
  }, [code, navigate, t]);

  const onChangeCode = useCallback(
    (e: any) => {
      const value = e.target.value || '';
      const _code = value.trim();

      setCode(_code);

      if (_code) {
        if (/^[\w]{10}$/.test(_code)) {
          setErrorMsg('');
          setCode(_code.toUpperCase());
          return;
        }
        setErrorMsg(/^[\w]{1,10}$/.test(_code) ? '' : t('gift_card_error'));
      }
    },
    [t],
  );

  useEffect(() => {
    return () => {
      Modal.close();
      Toast.destroy();
    };
  }, []);

  return {
    state: {
      checking,
      code,
      errorMsg,
    },
    action: {
      onChangeCode,
      onCheckCode,
      onClickUseRules,
    },
  };
};

export default useGiftCardForm;
